import { render, staticRenderFns } from "./CardHistorico.vue?vue&type=template&id=5d454170"
import script from "./CardHistorico.vue?vue&type=script&lang=js"
export * from "./CardHistorico.vue?vue&type=script&lang=js"
import style0 from "./CardHistorico.vue?vue&type=style&index=0&id=5d454170&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports